import React from "react";
import { Sheet, Table } from "@mui/joy";
import type { PeriodStats } from "../../../api/stats/Stats.typed";
import DarkTypography from "../../common/DarkTypography";
import { hrCompactTableSx, hrSheetSx } from "../../../styles/globalStyles";
import type { StatsTemplateTableConfig } from "../statsPeriodHelpers";
import StatsMetricValue from "./StatsMetricValue";

type StatsTemplateTableProps = {
  config: StatsTemplateTableConfig;
  stats: PeriodStats;
};

export default React.memo(function StatsTemplateTable({ config, stats }: StatsTemplateTableProps) {
  const rows = config.rows(stats);

  if (rows.length === 0) {
    return (
      <DarkTypography level="body-sm" colorVariant="muted">
        {config.emptyLabel}
      </DarkTypography>
    );
  }

  const totals = config.totals(stats);

  return (
    <Sheet sx={hrSheetSx}>
      <Table size="sm" sx={hrCompactTableSx}>
        <thead>
          <tr>
            <th style={{ width: "32%" }}>Modèle</th>
            {config.columns.map((column) => (
              <th key={column.label} style={{ textAlign: "center", whiteSpace: "normal" }}>
                {column.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.key}>
              <td style={{ wordBreak: "break-word" }}>
                <DarkTypography level="body-sm">{row.label || "Sans modèle"}</DarkTypography>
              </td>
              {config.columns.map((column, index) => (
                <td key={column.label} style={{ textAlign: "center" }}>
                  <StatsMetricValue tone={column.tone} value={String(row.values[index] ?? 0)} />
                </td>
              ))}
            </tr>
          ))}
          <tr>
            <td>
              <DarkTypography level="body-sm" colorVariant="title" sx={{ fontWeight: "bold" }}>
                Total
              </DarkTypography>
            </td>
            {config.columns.map((column, index) => (
              <td key={column.label} style={{ textAlign: "center" }}>
                <StatsMetricValue tone={column.tone} value={String(totals[index] ?? 0)} />
              </td>
            ))}
          </tr>
        </tbody>
      </Table>
    </Sheet>
  );
});
